module.exports = __webpack_public_path__ + "img/58.89c11a4.svg";